class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  async refresh(dontRefreshCartItems) {
    try {
      const response = this.getSectionsToRender().map((section) => section.id);
      const cartResponse = await fetch(`?sections=${response.join(",")}`);
      const sections = await cartResponse.json();
      let ADDTOCART_OBJECT = {
        sections: sections,
        id: window.glood.product.id,
      };
      this.renderContents(ADDTOCART_OBJECT);
      if (this.classList.contains("is-empty"))
        this.classList.remove("is-empty");
    } catch (error) {
      console.log(error); // eslint-disable-line
      this.dispatchEvent(
        new CustomEvent("on:cart:error", {
          bubbles: true,
          detail: {
            error: error,
          },
        })
      );
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelectorAll("#cart-icon-bubble");

    cartLink.forEach((link) => {
      link.setAttribute("role", "button");
      link.setAttribute("aria-haspopup", "dialog");
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(link);
      });
      link.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(link);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner .drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    checkForVirtualBundle();
    applyCouponFromSession();
    document.body.classList.add("no-scroll");
  }

  close() {
    this.classList.remove("active");
    const headerDocker = document.querySelector("header-docker");
    if (headerDocker) {
      if (headerDocker.classList.contains("open__docker")) {
        headerDocker.classList.remove("open__docker");
        headerDocker.classList.add("closed__dock");
      }
    }
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("no-scroll");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.getSectionsToRender().forEach((section) => {
      const parsedSectionHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
      if (section.id === "cart-drawer") {
        const sectionElement = document.querySelector(section.selector);
        if (sectionElement) {
          sectionElement.innerHTML = parsedSectionHTML;
        }
      } else {
        const arraySectionElements = document.querySelectorAll(
          `#${section.id}`
        );
        arraySectionElements.forEach((element) => {
          if (element) {
            element.innerHTML = parsedSectionHTML;
          }
        });
      }
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class VirtualBundleRemoveButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      let formData = {
        updates: {},
        sections: {},
      };

      let myArray = [];
      let virtualBundleLineItems = document.querySelectorAll(
        ".virtual-bundle-products-id"
      );

      virtualBundleLineItems.forEach((element) => {
        let mainProductId = this.closest(
          ".mm-ajaxcart-item.main-product-image"
        ).getAttribute("data-main-product-id");
        let elementId = element.getAttribute("data-main-product-id");
        if (mainProductId === elementId) {
          let variantId = element.getAttribute("data-variant-id");
          myArray.push(variantId);
        }
      });

      // Populate update object
      myArray.forEach((productID) => {
        formData["updates"][productID] = 0;
      });

      let cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");

      formData["sections"] = cart
        .getSectionsToRender()
        .map((section) => section.id);

      if (myArray.length > 0) {
        fetch("/cart/update.js", {
          body: JSON.stringify(formData),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
        })
          .then((response) => response.json())
          .then((data) => {
            const cartDrawer =
              document.querySelector("cart-drawer") ||
              document.querySelector("cart-notification");
            if (cartDrawer) {
              cartDrawer.renderContents(data);
              if (data.item_count == 0) {
                cartDrawer.classList.add("is-empty");
              }
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    });
  }
}

customElements.define(
  "virtual-bundle-remove-button",
  VirtualBundleRemoveButton
);

// Cart Offers
class DiscountToggle extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector("#discount-toggle-container");
    const discountContainer = this.querySelector(".discount-main-container");
    const headerLogo = document.querySelector(".drawer__header");
    const ajaxCartBody = document.querySelector("cart-drawer-items");
    const headerWrapper = document.querySelector(".drawer__header__content");
    const backButton = this.querySelector(".back-button-discount-header");
    const cartFooter = document.querySelector(".drawer__footer");
    const cartUpsellWrapper = document.querySelector(".cart-upsell-wrapper");
    const cartCheckBoxes = document.querySelector(".cart-checkboxes");
    // Initialize with hidden state
    discountContainer.classList.add("hidden");

    // Trigger click event handler
    trigger.addEventListener("click", () => {
      document
        .querySelector(".drawer.active .drawer__inner")
        ?.classList.add("show-cart-offers");
      discountContainer.classList.remove("hidden");
      discountContainer.classList.add("visible");
      trigger.classList.add("hidden");
      if (ajaxCartBody) {
        document.querySelector("#CartDrawer-CartItems").classList.add("hidden");
        document
          .querySelector("#CartDrawer-CartItems")
          .classList.remove("visible");
        document.querySelector("#CartDrawer-Form").classList.add("hidden");
        document.querySelector("#CartDrawer-Form").classList.remove("visible");

        if (cartUpsellWrapper) {
          cartUpsellWrapper.classList.add("hidden");
          cartUpsellWrapper.classList.remove("visible");
        }

        if (headerWrapper) {
          headerWrapper.classList.add("hidden");
          headerWrapper.classList.remove("visible");
        }

        if (cartCheckBoxes) {
          cartCheckBoxes.classList.add("hidden");
          cartCheckBoxes.classList.remove("visible");
        }

        cartFooter.classList.add("hidden");
        headerLogo?.classList.add("hidden");
      }
    });

    // Back button event handler
    if (backButton) {
      backButton.addEventListener("click", () => {
        discountContainer.classList.remove("visible");
        discountContainer.classList.add("hidden");
        document
          .querySelector(".drawer.active .drawer__inner")
          ?.classList.remove("show-cart-offers");
        trigger.classList.remove("hidden");
        if (ajaxCartBody) {
          document
            .querySelector("#CartDrawer-CartItems")
            .classList.remove("hidden");
          document
            .querySelector("#CartDrawer-CartItems")
            .classList.add("visible");
          document.querySelector("#CartDrawer-Form").classList.remove("hidden");
          document.querySelector("#CartDrawer-Form").classList.add("visible");
          cartUpsellWrapper?.classList.remove("hidden");
          cartUpsellWrapper?.classList.add("visible");
          headerWrapper?.classList.remove("hidden");
          headerWrapper?.classList.add("visible");
          cartCheckBoxes?.classList.remove("hidden");
          cartCheckBoxes?.classList.add("visible");
          cartFooter?.classList.remove("hidden");
          headerLogo?.classList.remove("hidden");
        }
      });
    }
  }
}

customElements.define("discount-toggle", DiscountToggle);

class OfferToggle extends HTMLElement {
  connectedCallback() {
    const allOffersBtn = this.querySelector(".all-offers-btn");
    const bankOffersBtn = this.querySelector(".bank-offers-btn");
    const otherOffersBtn = this.querySelector(".other-offers-btn");
    const allOfferContainers = this.querySelectorAll(
      ".all-offer-combined-container > div"
    );

    // default fn: show all offers
    this.toggleOffers("all", allOfferContainers);
    this.setSelected(allOffersBtn);

    // togoggle functionality
    if (allOffersBtn) {
      allOffersBtn.addEventListener("click", () => {
        this.toggleOffers("all", allOfferContainers);
        this.setSelected(allOffersBtn);
      });
    }

    if (bankOffersBtn) {
      bankOffersBtn.addEventListener("click", () => {
        this.toggleOffers("bank", allOfferContainers);
        this.setSelected(bankOffersBtn);
      });
    }

    if (otherOffersBtn) {
      otherOffersBtn.addEventListener("click", () => {
        this.toggleOffers("other", allOfferContainers);
        this.setSelected(otherOffersBtn);
      });
    }
  }

  toggleOffers(type, containers) {
    containers.forEach((container) => {
      if (type === "all") {
        container.style.display = "block";
      } else {
        const offerType = container.getAttribute("data-offer-type");
        container.style.display = offerType === type ? "block" : "none";
      }
    });
  }

  setSelected(button) {
    this.querySelectorAll(".toggle-button-discount button").forEach((btn) => {
      btn.classList.remove("selected");
    });
    button.classList.add("selected");
  }
}

customElements.define("offer-toggle", OfferToggle);

// discount re-rendering

function applyCouponFromSession() {
  const checkoutButton = document.getElementById("proceed-checkout-button");
  const applyCouponBtn = document.querySelector("#apply-coupon-btn");
  if (checkoutButton) {
    checkoutButton
      .querySelector(".checkout-ldr__text")
      .classList.add("tw-hidden");
    checkoutButton.querySelector(".loader").classList.remove("tw-hidden");
    checkoutButton.style.cursor = "not-allowed";
  }

  if (document.querySelector("#discount-toggle-container")) {
    document.querySelector("#discount-toggle-container").style.opacity = "0.5";
    document.querySelector(".af_popup_trigger").disabled = "true";
  }

  // Check for the coupon key in sessionStorage
  const savedCouponCode = window.sessionStorage.getItem("custom_coupon-code");

  function shouldHandleDiscount() {
    return new Promise((resolve) => {
      if (sessionStorage.getItem("fromCheckout")) {
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            if (
              cart.total_discount === 0 &&
              cart.cart_level_discount_applications.length === 0
            ) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
      } else {
        resolve(false);
      }
    });
  }

  shouldHandleDiscount().then(async (shouldHandle) => {
    if (shouldHandle) {
      sessionStorage.removeItem("fromCheckout");
      sessionStorage.removeItem("custom_coupon-code");
    } else {
      if (savedCouponCode) {
        if (sessionStorage.getItem("fromCheckout")) {
          fetch(`/discount/${savedCouponCode}/clear`)
            .then((data) => {})
            .catch((error) => {
              console.error("Error adding product to cart:", error);
            });

          // re render cart
          const cartDrawer =
            document.querySelector("cart-drawer") ||
            document.querySelector("cart-notification");

          const sectionsToRender = cartDrawer
            .getSectionsToRender()
            .map((section) => section.id);

          // Get section HTMLs from the server
          const response = await fetch(
            `/cart?sections=${sectionsToRender.join(",")}`
          );
          const sectionHTML = await response.json();

          const payload = {
            sections: sectionHTML,
          };

          cartDrawer.renderContents(payload);
          sessionStorage.removeItem("fromCheckout");
        }

        const interval = setInterval(() => {
          const couponField = document.querySelector("#custom-discount-text");
          if (couponField) {
            clearInterval(interval);

            if (couponField) {
              couponField.value = savedCouponCode;
            }

            if (typeof Shopify.CustomDiscountSubmit === "function") {
              Shopify.CustomDiscountSubmit(savedCouponCode);
            } else {
              console.error("Shopify.CustomDiscountSubmit function not found.");
            }
          }
        }, 300);
      } else {
        console.error("No coupon found in sessionStorage.");
      }
    }
  });

  // Hide the loader after the process is complete
  setTimeout(() => {
    if (checkoutButton) {
      checkoutButton
        .querySelector(".checkout-ldr__text")
        .classList.remove("tw-hidden");
      checkoutButton.querySelector(".loader").classList.add("tw-hidden");
      checkoutButton.style.cursor = "pointer";
    }

    if (document.querySelector("#discount-toggle-container")) {
      document.querySelector("#discount-toggle-container").style.opacity = "1";
      document.querySelector(".af_popup_trigger").removeAttribute("disabled");
    }
  }, 4500);
}
